var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner.data)?_c('div',{staticClass:"material-banner"},[(_vm.banner.data.designVariant === 1)?_c('material-banner-variant1',{attrs:{"banner":_vm.banner.data.payload}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }